module.exports = __webpack_public_path__ + "img/DE02724.f97d3a42.png";